import type { ReactNode } from "react";
import { useState } from "react";
import Capsule from "ui/components/Capsule";
import styles from "./PlanLibraryBadge.module.scss";

export interface PlanLibraryBadgeProps {
  onClickBadge?: () => void;
  isOverridden?: boolean;
  isBaseOption?: boolean;
  singleField?: boolean;
}

export function PlanLibraryBadge({ onClickBadge, isOverridden, isBaseOption, singleField }: PlanLibraryBadgeProps) {
  const [hovering, setHovering] = useState<boolean>(false);
  let capsule: ReactNode;

  if (isBaseOption) {
    return (
      <div className={styles.optionSetBadge}>
        <Capsule label="Base" size="small" color="white" backgroundColor="stone" />
      </div>
    );
  } else if (isOverridden) {
    if (hovering) {
      capsule = (
        <Capsule label={`Discard Override${singleField ? "" : "s"}`} size="small" style={{ cursor: "pointer" }} />
      );
    } else {
      capsule = <Capsule label="Overridden" color="white" size="small" backgroundColor="sapphireLight" />;
    }
  } else {
    capsule = <Capsule label="Inherit" size="small" />;
  }

  return (
    <div
      className={styles.optionSetBadge}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onClick={(e) => {
        if (isOverridden && hovering && onClickBadge) {
          e.stopPropagation();
          onClickBadge();
        }
      }}
    >
      {capsule}
    </div>
  );
}
